module.exports = __webpack_public_path__ + "static/media/ig11.c51a934d.jpg";